import "./LogoGooglePay.scss";

const LogoGooglePay: React.FC<SVGProps<SVGSVGElement>> = () => (
  <svg
    version="1.2"
    viewBox="0 0 143 76"
    width="81"
    height="28"
    className="option__nuvei-logo google-pay"
  >
    <title>Google_Pay_Logo-svg</title>

    <g id="Google_Pay_Lockup_1_">
      <g id="Pay_Typeface_3_">
        <path
          id="Letter_p_3_"
          fill-rule="evenodd"
          className="s0"
          d="m68.2 52.2h-3.6v-28.4h9.7q3.6 0 6.2 2.5 2.6 2.4 2.6 5.9 0 3.7-2.6 6.1-2.5 2.4-6.2 2.4h-6.1zm0-15h6.1q2.2 0 3.6-1.5 1.5-1.4 1.5-3.5 0-1.9-1.5-3.4-1.4-1.5-3.6-1.5h-6.1z"
        />
        <path
          id="Letter_a_3_"
          fill-rule="evenodd"
          className="s0"
          d="m92.7 32.1q4 0 6.3 2.2 2.4 2.2 2.4 5.9v12h-3.5v-2.7h-0.2q-2.2 3.3-6 3.3-3.2 0-5.3-1.9-2.2-1.9-2.2-4.7 0-3.1 2.3-4.8 2.2-1.8 6-1.8 3.3 0 5.4 1.2v-0.8q0-1.9-1.5-3.3-1.5-1.3-3.6-1.3-3 0-4.8 2.6l-3.2-2q2.7-3.9 7.9-3.9zm-4.8 14.1q0 1.5 1.3 2.4 1.2 0.9 2.8 1 2.3 0 4.1-1.8 1.8-1.7 1.8-4-1.7-1.3-4.8-1.3-2.2 0-3.7 1-1.5 1.2-1.5 2.7z"
        />
        <path
          id="Letter_y_3_"
          className="s0"
          d="m121.2 32.8l-12.2 27.9h-3.7l4.5-9.8-8-18.1h4l5.7 13.9h0.1l5.6-13.9z"
        />
      </g>
      <g id="Google_Mark_1_">
        <path
          id="Blue_500"
          className="s1"
          d="m53.7 38.4q0-1.8-0.3-3.4h-15.3v6.2h8.8c-0.3 2.1-1.5 3.9-3.2 5.1v4h5.2c3.1-2.8 4.8-7 4.8-11.9z"
        />
        <path
          id="Green_500_1_"
          className="s2"
          d="m43.7 46.3c-1.5 1-3.4 1.5-5.6 1.5-4.2 0-7.8-2.8-9.1-6.7h-5.4v4.2c2.7 5.3 8.2 9 14.5 9 4.4 0 8.1-1.5 10.8-4z"
        />
        <path
          id="Yellow_500_1_"
          className="s3"
          d="m28.5 38q0-1.6 0.5-3.1v-4.2h-5.4c-1.1 2.2-1.7 4.7-1.7 7.3 0 2.6 0.6 5.1 1.7 7.3l5.4-4.2q-0.5-1.5-0.5-3.1z"
        />
        <path
          id="Red_500"
          className="s4"
          d="m38.1 28.2c2.4 0 4.6 0.8 6.3 2.4l4.6-4.6c-2.8-2.7-6.5-4.3-10.9-4.3-6.3 0-11.8 3.7-14.5 9l5.4 4.2c1.3-3.9 4.9-6.7 9.1-6.7z"
        />
      </g>
    </g>
  </svg>
);

export default LogoGooglePay;
